import { InfoCircleOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { RecordType } from 'app/constants/GlobalTypes'
import { normalizeAddressSummary } from 'app/lib/apollo/normalizers/Rental'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

const Address: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (!children) return null
  return <strong>: {children}</strong>
}

const LocalAvailabilityHint: React.FC<{ rental: IRental }> = ({ rental }) => {
  const { tCore } = useTranslation({
    recordType: RecordType.checkout,
    scope: 'info'
  })
  const address = normalizeAddressSummary(rental?.deliveryAddress)

  return (
    <Space>
      <InfoCircleOutlined style={{ fontSize: '20px' }} />
      <div>
        {tCore({ id: 'local_availability_hint' })}
        <Address>{address}</Address>
      </div>
    </Space>
  )
}

export default LocalAvailabilityHint
